<app-navbar title="Użytkownicy">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-dynamic-table [elements]="data" [tableRows]="tableRows" module="users"></app-dynamic-table>
